<template>
    <div class="vehicle-container">
        <div class="vehicle">
            <div class="row" v-if="vehicle">
                <div :class="{'col-md-6': !hideBtn, 'col-md-12': hideBtn}">
                    <span class="d-block no-bottom-margin plate-number"><b>{{vehicle._plateNo}}</b></span>
                    <span class="d-block category" v-if="type == 'vignette' && vehicle.category_vignette"><b>{{vehicle.category_vignette.title}}</b></span>
                    <span class="d-block category" v-if="type == 'toll' && vehicle.category_toll"><b>{{vehicle.category_toll.title}}</b></span>
                    <span class="d-block category" v-if="vehicle._chasisNo">{{vehicle._chasisNo}}</span>
                    <span class="d-block category" v-if="vehicle.country.country">{{vehicle.country.country}}</span>
                </div>
                <div class="col-md-6 d-flex align-items-center mt-3 mt-md-0" v-if="!hideBtn">
                    <router-link :to="{ name: 'vignette-category', params: {id: vehicle.category_vignette.id, carId: vehicle.id}}" class="btn main-btn" v-if="type == 'vignette'">
                        <i class="fas fa-cart-plus"></i> {{$t('vignette_buy')}}
                    </router-link>
                    <router-link :to="{ name: 'toll-category', params: {id: vehicle._category_TPF, carId: vehicle.id}}" class="btn main-btn" v-if="type == 'toll'">
                        <i class="fas fa-cart-plus"></i> {{$t('toll_buy')}}
                    </router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'AddProductForVehicle',
        props: {
            vehicle: {
                type: Object,
                default: null
            },
            type: {
                type: String,
                default: 'vignette'
            },
            hideBtn: {
                type: Boolean,
                default: false
            }
        },
    }
</script>

<style lang="scss" scoped>
    .vehicle {
        background: #EEEDEC;
        padding: 20px;

        .plate-number {
            font-size: 22px;
        }
    }
</style>
